export interface IAvgStats {
  EventCountNLastDays: number | null;
  EventTotalTime: number | null;
  MaxSpeedNLastDays: string | null;
  TotalDistance: number | null;
  AverageDistance: number | null;
  RunDistanceTotal: number | null;
  RunDistancePercentage: string | null;
  HSRDistanceTotal: number | null;
  HSRDistancePercentage: string | null;
  SprintDistanceTotal: number | null;
  SprintDistancePercentage: string | null;
  SprintNumberTotal: number | null;
  TimeToSprintInSeconds: string | null;
  HMLDDistance: number | null;
  HMLDDistancePercentage: string | null;
  AccelerationNumberTotal: number | null;
  DecelerationNumberTotal: number | null;
  MaxPowerOutput: string | null;
  MaxHeartRate: number | null;
  HeartRateLastNDaysAvg: number | null;
  HeartRate1ZonePercentage: number | null;
  HeartRate2ZonePercentage: number | null;
  HeartRate3ZonePercentage: number | null;
  HeartRate4ZonePercentage: number | null;
  HeartRate5ZonePercentage: number | null;
  HRR: number | null;
  DynamicPercentage: number | null;
  IntensityPercentage: number | null;
  EndurancePercentage: number | null,

  Form?: number | null,
  Readiness?: number | null,
  Potential?: number | null,
  EventTotalTimeInMinutes?: number | null,
  MdnRunDistancePercentage?: number | null,
  MdnHSRDistancePercentage?: number | null,
  MdnSprintDistancePercentage?: number | null,
  MdnHMLDPercentage?: number | null,
  MdnSpeedNLastDays?: number | null,
  BurnCalories?: number | null,
  Load?: number | null;

  MdnDistanceTotal?: number | null;
  MdnRunTotal?: number | null;
  MdnHSRTotal?: number | null;
  MdnHMLDTotal?: number | null;
  MdnSprintTotal?: number | null;
  PowerTime?: number | null;

}

export interface Academy {
  Id: string;
  Name: string;
}

export interface IPlayerStats {
  Group: string | null;
  Academy: Academy;
  FirstName: string;
  LastName: string;
  PreferredPosition: number | null;
  Age: number | null;
  PHV: number | null;
  Form: number | null;
  Readiness: number | null;
  Potential: number | null;
  EventCountNLastDays: number | null;
  EventTotalTimeInMinutes: number | null;
  MaxSpeedNLastDays: string | null;
  TotalDistance: number | null;
  AverageDistance: number | null;
  RunDistanceTotal: number | null;
  RunDistancePercentage: string | null;
  HSRDistanceTotal: number | null;
  HSRDistancePercentage: string | null;
  SprintDistanceTotal: number | null;
  SprintDistancePercentage: string | null;
  SprintNumberTotal: number | null;
  TimeToSprintInSeconds: string | null;
  HMLDDistance: number | null;
  HMLDDistancePercentage: string | null;
  AccelerationNumberTotal: number | null;
  DecelerationNumberTotal: number | null;
  MaxPowerOutput: string | null;
  MaxHeartRate: number | null;
  HeartRateLastNDaysAvg: number | null;
  HeartRate1ZonePercentage: number | null;
  HeartRate2ZonePercentage: number | null;
  HeartRate3ZonePercentage: number | null;
  HeartRate4ZonePercentage: number | null;
  HeartRate5ZonePercentage: number | null;
  HRR: number | null;
  DynamicPercentage: number | null;
  EnergyPercentage: number | null;
  EndurancePercentage: number | null;

  PlayerId?: string | null;
  TimelineSummary?: PlayerTimelineSummaryDTO | null;
}

export interface PlayerTimelineSummaryDTO {
  playerId: string;
  goals: number | null;
  penalties: number | null;
  yellowCards: number | null;
  redCards: number | null;
  timeOnField: number | null;
}

export const avgHomeStatsInitialValues: IAvgStats = {
  EventCountNLastDays: 0,
  EventTotalTime: 0,
  MaxSpeedNLastDays: '0.00',
  TotalDistance: 0,
  AverageDistance: 0,
  RunDistanceTotal: 0,
  RunDistancePercentage: '0.00',
  HSRDistanceTotal: 0,
  HSRDistancePercentage: '0.00',
  SprintDistanceTotal: 0,
  SprintDistancePercentage: '0.00',
  SprintNumberTotal: 0,
  TimeToSprintInSeconds: '0.00',
  HMLDDistance: 0,
  HMLDDistancePercentage: '0.00',
  AccelerationNumberTotal: 0,
  DecelerationNumberTotal: 0,
  MaxPowerOutput: '0.00',
  MaxHeartRate: 0,
  HeartRateLastNDaysAvg: 0,
  HeartRate1ZonePercentage: 0,
  HeartRate2ZonePercentage: 0,
  HeartRate3ZonePercentage:0,
  HeartRate4ZonePercentage:0,
  HeartRate5ZonePercentage: 0,
  HRR: 0,
  DynamicPercentage:0,
  IntensityPercentage: 0,
  EndurancePercentage: 0,

  Form: 0,
  Readiness: 0,
  Potential : 0,
  EventTotalTimeInMinutes:0,
};


export interface Academy {
  Id: string;
  Name: string;
}

export interface PlayerStats {
  PlayerId: string | null;
  Group: string | null;
  Academy: Academy | null;
  FirstName: string | null;
  LastName: string | null;
  PreferredPosition: number;
  Age: number | null;
  PHV: number | null;
  Form: string | number;
  Readiness: number | null;
  Potential: number | null;
  EventCountNLastDays: number | null;
  EventTotalTimeInMinutes: number | null;
  MaxSpeedNLastDays: string | null;
  TotalDistance: number | null;
  AverageDistance: number | null;
  RunDistanceTotal: number | null;
  RunDistancePercentage: string | null;
  HSRDistanceTotal: number | null;
  HSRDistancePercentage: string | null;
  SprintDistanceTotal: number | null;
  SprintDistancePercentage: string | null;
  SprintNumberTotal: number | null;
  TimeToSprintInSeconds: string | null;
  HMLDDistance: number | null;
  HMLDDistancePercentage: string | null;
  AccelerationNumberTotal: number | null;
  DecelerationNumberTotal: number | null;
  MaxPowerOutput: string | null;
  MaxHeartRate: number | null;
  HeartRateLastNDaysAvg: number | null;
  HeartRate1ZonePercentage: number | null;
  HeartRate2ZonePercentage: number | null;
  HeartRate3ZonePercentage: number | null;
  HeartRate4ZonePercentage: number | null;
  HeartRate5ZonePercentage: number | null;
  HRR: number | null;
  DynamicPercentage: number | null;
  EnergyPercentage: number | null;
  EndurancePercentage: number | null;
  IntensityPercentage: number | null;
}

export interface PlayerStatisticsPeriod {
  [key: string]: PlayerStats;
}



export interface IPlayerTrendData {
  PlayerStatistics: {
    "prev": PlayerStats[];
    "current": PlayerStats[];
  };
}
